const MODE = {
  OFFLINE: 'offline',
  CONNECT: 'connect',
  SHARE: 'share',
};

export { MODE };



// WEBPACK FOOTER //
// ./src/constants.js